import { render, staticRenderFns } from "./PathHistory.vue?vue&type=template&id=210fd177&scoped=true"
import script from "./PathHistory.vue?vue&type=script&lang=js"
export * from "./PathHistory.vue?vue&type=script&lang=js"
import style0 from "./PathHistory.vue?vue&type=style&index=0&id=210fd177&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210fd177",
  null
  
)

export default component.exports